import { Component } from '@angular/core';
import { ApplicationList } from '../../model/application/application-list.model';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { PageInfo } from '../../../../core/model/pagination/page-info';
import { ItemStatus } from '../../../shared/enums/item-status.enum';
import { EnabledApplicationAdapter } from './enabled-application-adapter';
import { ApplicationsState } from '../../applications.state';
import { selectEnabledApplicationList } from '../../application.selector';
import { asRouterParams } from '../../../shared/helper/router-params';
import * as RouterActions from '../../../../core/actions/router.actions';
import { Globals } from '../../../../app.globals';
import { ModuleRoutingConstants } from '../../../../core/helpers/module-routing.constants';

/**
 * Container component for enabled applications - contains behavior.
 */
@Component({
    selector: 'ssf-enabled-application-list',
    template: require('./enabled-application-list.component.html')
})
export class EnabledApplicationListComponent {
    ItemStatus = ItemStatus; // so we can use ItemStatus enum in template, has to be public otherwise tslint complains
    enabledApplicationList$: Observable<ApplicationList>;
    pageSize: number;
    adapter = new EnabledApplicationAdapter();

    constructor(private store: Store<ApplicationsState>) {
        this.enabledApplicationList$ = this.store.select(selectEnabledApplicationList);
        this.pageSize = Globals.itemsPerPage.common;
    }

    onLoadPage(pageInfo: PageInfo): void {
        this.store.dispatch(
            new RouterActions.Go({
                path: ModuleRoutingConstants.APPLICATIONS_ROUTER,
                query: asRouterParams(pageInfo),
            }));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/components/enabled-application-list/enabled-application-list.component.ts